import React from 'react';

const sizes = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12' };

export default function LoadingSpinner({ size = 'md', className = '' }) {
  return (
    <div className={`${sizes[size]} ${className}`}>
      <div className="w-full h-full rounded-full border-3 border-primary-200 border-t-primary-600 animate-spin" style={{ borderWidth: 3 }} />
    </div>
  );
}

export function SkeletonCard({ rows = 3 }) {
  return (
    <div className="glass-card p-5 animate-fade-in">
      <div className="skeleton h-4 w-32 mb-4" />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton h-3 mb-2" style={{ width: `${60 + Math.random() * 35}%` }} />
      ))}
    </div>
  );
}

export function PageLoader() {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <LoadingSpinner size="lg" className="mx-auto mb-3" />
        <p className="text-slate-400 text-sm">Loading data...</p>
      </div>
    </div>
  );
}
